import { useEffect, useState } from "react";
import "@/styles/editorial.css";
import { Header, scrollToId } from "./components/Header";
import { LogRail } from "./components/fx/LogRail";
import { HeroCover } from "./components/editorial/HeroCover";
import { OppositeSpread } from "./components/editorial/OppositeSpread";
import { QuadriBands } from "./components/editorial/QuadriBands";
import { FacultyIndex } from "./components/editorial/FacultyIndex";
import { PrefaceSpread } from "./components/editorial/PrefaceSpread";
import { OperatorConsole } from "./components/editorial/OperatorConsole";
import { Closing, Colophon } from "./components/editorial/Closing";

function App() {
  const [unlocked, setUnlocked] = useState(false);
  const [scrollReq, setScrollReq] = useState(0);

  useEffect(() => {
    if (scrollReq) requestAnimationFrame(() => scrollToId("acquista"));
  }, [scrollReq]);

  const handleReject = () => {
    setUnlocked(true);
    setScrollReq((n) => n + 1);
  };

  return (
    <div className="site" data-testid="landing-page">
      <div className="grain" aria-hidden="true" />
      <div className="scanlines" aria-hidden="true" />
      <Header />
      <LogRail />
      <main>
        <HeroCover />
        <OppositeSpread />
        <QuadriBands />
        <FacultyIndex />
        <PrefaceSpread />
        <OperatorConsole onReject={handleReject} />
        {unlocked && <Closing />}
      </main>
      <Colophon />
    </div>
  );
}

export default App;
